import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AdminProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);
  const [localStorageChecked, setLocalStorageChecked] = useState(false);
  const [localStorageUser, setLocalStorageUser] = useState(null);

  // Check localStorage directly on mount
  useEffect(() => {
    const checkLocalStorage = () => {
      try {
        const savedUser = localStorage.getItem('anadolu-user');
        const authToken = localStorage.getItem('authToken');
        
        // Parse user data if available
        let parsedUser = null;
        if (savedUser) {
          try {
            parsedUser = JSON.parse(savedUser);
          } catch (e) {
            // Invalid user data
          }
        }
        
        // Oturum yalnızca gerçek bir token varsa geçerli sayılır;
        // asıl yetki kontrolü backend'de token'ın role claim'i üzerinden yapılır.
        if (authToken && parsedUser) {
          if (parsedUser.role === 'admin' || parsedUser.email === 'admin@eticaret.com') {
            setLocalStorageUser(parsedUser);
          }
        }
        
        setLocalStorageChecked(true);
      } catch (error) {
        setLocalStorageChecked(true);
      }
    };
    
    checkLocalStorage();
  }, []);

  // Check if user is admin (from AuthContext or localStorage)
  const isAdminFromContext = user && (user.role === 'admin' || user.email === 'admin@eticaret.com');
  const isAdminFromStorage = localStorageUser && (localStorageUser.role === 'admin' || localStorageUser.email === 'admin@eticaret.com');
  const isAdmin = isAdminFromContext || isAdminFromStorage;

  // Wait for auth check to complete
  useEffect(() => {
    // Only set checking to false when loading is complete AND localStorage is checked
    if (!loading && localStorageChecked) {
      // Small delay to ensure AuthContext state is fully updated
      const timeout = setTimeout(() => {
        setIsCheckingAuth(false);
      }, 50);
      
      return () => clearTimeout(timeout);
    }
  }, [loading, localStorageChecked]);

  // Show loading state while checking authentication
  if (loading || isCheckingAuth || !localStorageChecked) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  // Only redirect if we're done loading and user is not admin
  if (!loading && !isCheckingAuth && localStorageChecked && !isAdmin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminProtectedRoute;

